module.exports = __webpack_public_path__ + "static/media/IMG_0402.302d8820.JPG";